import React, { useEffect } from 'react';
import { IVenueListSelect } from './types';
import style from './style.module.scss';
import { Button, CircularProgress, Divider, Drawer, fade, IconButton, makeStyles, TextField, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/main/rootReducer';
import { handleOpenVenueListDrawer, IVenue, setSelectedVenue, setVenues } from 'app/reducers/venueSlice';
import { Close, Search as SearchIcon } from '@material-ui/icons';
import Autocomplete from '@material-ui/lab/Autocomplete';
import venueService from 'app/services/venue.service';

const NS = 'VenueListSelect';

const venueListDrawerWidth = 360
const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    root: {
        display: 'flex',
    },
    venueListDrawer: {
        width: venueListDrawerWidth,
        flexShrink: 0,
    },
    venueListDrawerPaper: {
        width: venueListDrawerWidth,
    },
    venueListDrawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: 'flex-start',
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    okButton: {
      marginTop: theme.spacing(2),
      flexDirection: 'row',
    },
}));

export default function VenueListSelect({ handleSomeClick}: IVenueListSelect) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [ autoCompleteSelectedVenue, setAutoCompleteSelectedVenue ] = React.useState({} as IVenue);
  const { loggedInUser } = useSelector((state: RootState) => state.loginUserReducer);
  const { openVenueListDrawer, venues } = useSelector((state: RootState) => state.venueReducer);
  const loading = open && venues.length === 0;
  
  const handleVenueListDrawerClose = () => {
    dispatch(handleOpenVenueListDrawer(false));
  }

  const handleVenueSelection = () => {
    if (autoCompleteSelectedVenue && autoCompleteSelectedVenue.id) {
      dispatch(setSelectedVenue(autoCompleteSelectedVenue));
      handleVenueListDrawerClose();
    }
  }

  return (
    <>
      <Drawer
        className={classes.venueListDrawer}
        variant="temporary"
        anchor="right"
        open={openVenueListDrawer}
        classes={{
            paper: classes.venueListDrawerPaper
        }}
      >
        <div className={classes.venueListDrawerHeader}>
            <IconButton onClick={handleVenueListDrawerClose}>
                <Close />
            </IconButton>
            <Typography variant="h6" noWrap className={classes.title}>Select A Venue:</Typography>
            <Divider />
        </div>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <Autocomplete
            id="async-Venue-List"
            style={{ width: '100%' }}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            getOptionSelected={(option, value) => option.name === value.name }
            getOptionLabel={(option) => option.name}
            options={venues}
            loading={loading}
            onChange={(event: any, value: IVenue) => {
              setAutoCompleteSelectedVenue(value);
              setOpen(false);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                label="search venue"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </div>
        <div style={{display: 'flex'}}>
          <Button style={{flexDirection: 'row-reverse' }} className={classes.okButton} variant="contained" color="primary" onClick={handleVenueSelection}>Ok</Button>
        </div>
      </Drawer>
    </>
  )
}